import { BaseSerializer } from "../../../shared/models/serializers/baseSerializer.ts";
import { TagGroup } from "../../../shared/models/tagGroup.model.ts";


export class TemplateTagSerializer extends BaseSerializer{

  public deserialize( data: any ): any {
    const gp = new TagGroup();
    this._copyAttributes(gp, data);
    return gp;

}
}
